<template>
  <KpiCard
    :icon="icon"
    :title="title"
    :iconType="iconType"
    :titleColor="titleColor"
    :iconColor="iconColor"
    :iconBgColor="iconBgColor"
    :iconBG="true"
  >
    <template #value>
      <div class="chart-main-container">
        <!-- Coluna esquerda: legendas -->
        <div class="legend-container">
          <div 
            v-for="(alert, index) in alerts" 
            :key="index" 
            class="legend-item"
          >
            <div class="legend-label"">
              <div 
                class="legend-bullet"
                :style="{ backgroundColor: alert.color }"
              ></div>
              <div class="legend-text">{{ alert.label }}</div>
            </div>
            <div class="legend-count">{{ alert.count }}</div>
          </div>
        </div>
        
      </div>
    </template>
    
   
  </KpiCard>
</template>

<script>
import Chart from 'chart.js';
import KpiCard from '@/pages/newDashboard/Widgets/KpiCard.vue';

export default {
  name: 'DoughnutAlertCard',
  components: {
    KpiCard
  },
  props: {
    // Props do KpiCard que vamos passar adiante
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    iconType: {
      type: String,
      default: 'material',
      validator: value => ['material', 'image'].includes(value)
    },
    titleColor: {
      type: String,
      default: '#63A9FF'
    },
    iconColor: {
      type: String,
      default: '#4092FF'
    },
    iconBgColor: {
      type: String,
      default: '#D0E5FF'
    },
    
    // Props específicas deste componente
    alerts: {
      type: Array,
      required: true,
      validator: value => 
        value.every(alert => 
          typeof alert.label === 'string' && 
          typeof alert.count === 'number' && 
          typeof alert.color === 'string'
        )
    }
  },
  computed: {
    total() {
      return this.alerts.reduce((sum, alert) => sum + alert.count, 0);
    }
  },
  data() {
    return {
      chart: null
    };
  },
  mounted() {
    this.createChart();
  },
  watch: {
    alerts: {
      handler() {
        this.updateChart();
      },
      deep: true
    }
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  },
  methods: {
    createChart() {
      if (!this.$refs.doughnut) return;
      
      const ctx = this.$refs.doughnut.getContext('2d');
      
      this.chart = new Chart(ctx, {
        type: 'doughnut',
        data: {
          datasets: [{
            data: this.alerts.map(alert => alert.count),
            backgroundColor: this.alerts.map(alert => alert.color),
            borderWidth: 0
          }]
        },
        options: {
          cutoutPercentage: 80,
          responsive: true,
          maintainAspectRatio: false,
          rotation: -Math.PI / 2,
          legend: {
            display: false
          },
          tooltips: {
            enabled: false
          },
          hover: {
            mode: null
          },
          animation: {
            animateRotate: true,
            animateScale: false
          },
          layout: {
            padding: {
              top: 0,
              bottom: 0,
              left: 0,
              right: 0
            }
          }
        }
      });
    },
    updateChart() {
      if (this.chart) {
        this.chart.destroy();
      }
      
      this.$nextTick(() => {
        if (this.total > 0) {
          this.createChart();
        }
      });
    }
  }
};
</script>

<style scoped>
.chart-main-container {
  height: calc(100vh - 680px); 
  min-height: 250px;
  width: 100%;
  display: flex;
  padding-top: 10px;
  justify-content: space-between;
}

.consumption-label {
  font-size: 0.9rem;
  font-weight: 600;
  color: #63A9FF;
  text-transform: uppercase;
  margin-bottom: 4px;
}

.legend-container {
  gap:6px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  width: 100%;
}

.legend-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  gap: 10px;
  align-self: stretch;
  border-radius: 8px;
  background: #EAF3FF;
}

.legend-label{
  display: flex; 
  align-items: center; 
  gap: 10px;
}

.legend-bullet {
  width: 20px;
  height: 20px;
  border-radius: 6px;
  flex-shrink: 0;
}

.legend-text {
  color:#1C1C1C;
  font-family: Manrope;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.legend-count{
  color:#1C1C1C;
  text-align: right;
  font-family: Manrope;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

canvas {
  width: 100% !important;
  height: 100% !important;
  display: block;
}

@media (max-width: 768px) {
  .legend-container {
    width: 45%;
  }
  
  canvas {
    max-width: none !important;
    max-height: none !important;
  }
  
  .consumption-label {
    font-size: 0.8rem;
  }
  
  .legend-label {
    font-size: 0.75rem;
  }
}

@media (min-width: 769px) {
  canvas {
    max-width: none !important;
    max-height: none !important;
  }
}
</style> 